import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, Checkbox, CircularProgress, FormControlLabel, Typography, Tabs, Tab, TextField, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import api from '../../../services/api';

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(4), maxWidth: 900 },
  card: { marginTop: theme.spacing(2) },
  actions: { marginTop: theme.spacing(3) },
  message: { marginTop: theme.spacing(2) }
}));
const initial = { integwhatsapp: 'N', adicionaddinumerotelefone: 'N', provedorwhatsapp: 0, urlbasewhatsappcloudapi: '', phonenumberidwhatsappcloudapi: '', businessaccountwhatsappcloudapi: '', businessidwhatsappcloudapi: '', accesstokenwhatsappcloudapi: '', urllink2bot: '', tokenlink2bot: '', tokenlink2botconfigurado: false };
const provedores = ['Selecione o provedor', 'Z-API', 'Twilio', 'ManyChat', 'Bradial', 'WhatsApp Cloud API (Meta)', 'Link2Bot (somente Web)'];

export default function ConfiguracaoGeralCRM() {
  const classes = useStyles();
  const [form, setForm] = useState(initial);
  const [tab, setTab] = useState(0);
  const [original, setOriginal] = useState(initial);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  const [loadFailed, setLoadFailed] = useState(false);
  const codempresa = Number(sessionStorage.getItem('codEmpresa') || 0);

  useEffect(() => {
    let active = true;
    api.get('/crm/configuracoes/geral', { params: { codempresa } })
      .then(({ data }) => {
        if (!active) return;
        const values = { ...initial, ...data, accesstokenwhatsappcloudapi: '', tokenlink2bot: '' };
        setForm(values);
        setOriginal(values);
      })
      .catch((e) => { if (active) { setError(true); setLoadFailed(true); setMessage(e.response?.data?.error || 'Não foi possível carregar as configurações.'); } })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [codempresa]);

  const toggle = (field) => (event, checked) => {
    const isChecked = typeof checked === 'boolean' ? checked : Boolean(event?.target?.checked);
    setMessage('');
    setForm((old) => ({ ...old, [field]: isChecked ? 'S' : 'N' }));
  };
  const salvar = async () => {
    setSaving(true);
    setMessage('');
    try {
      await api.put('/crm/configuracoes/geral', { codempresa, ...form });
      setOriginal({ ...form, accesstokenwhatsappcloudapi: '', tokenlink2bot: '', tokenlink2botconfigurado: form.tokenlink2botconfigurado || Boolean(form.tokenlink2bot) });
      setForm((old) => ({ ...old, accesstokenwhatsappcloudapi: '', tokenlink2bot: '', tokenlink2botconfigurado: old.tokenlink2botconfigurado || Boolean(old.tokenlink2bot) }));
      setError(false);
      setMessage('Configurações salvas com sucesso.');
    } catch (e) {
      setError(true);
      setMessage(e.response?.data?.error || 'Não foi possível salvar as configurações.');
    } finally { setSaving(false); }
  };

  if (loading) return <div className={classes.root}><CircularProgress size={28} /></div>;
  return (
    <div className={classes.root}>
      <Typography variant="h4">Configurações Gerais — CRM</Typography>
      <Typography color="textSecondary">Parâmetros de funcionamento do módulo CRM</Typography>
      <Card className={classes.card}><CardContent>
        <Tabs value={tab} onChange={(_, value) => setTab(value)} indicatorColor="primary" textColor="primary">
          <Tab label="Geral" />
          <Tab label="Integração WhatsApp" disabled={form.integwhatsapp !== 'S'} />
        </Tabs>
        {tab === 0 ? <div style={{ paddingTop: 16 }}>
          <FormControlLabel control={<Checkbox color="primary" checked={form.integwhatsapp === 'S'} onChange={(event, checked) => { toggle('integwhatsapp')(event, checked); if (!checked) setTab(0); }} disabled={saving || loadFailed} />} label="Envio de comunicados por WhatsApp" />
          <Typography variant="body2" color="textSecondary">Habilita a aba de integração WhatsApp.</Typography>
          <FormControlLabel control={<Checkbox color="primary" checked={form.adicionaddinumerotelefone === 'S'} onChange={toggle('adicionaddinumerotelefone')} disabled={saving || loadFailed} />} label="Adiciona DDI ao número de telefone" />
        </div> : <div style={{ paddingTop: 20 }}>
          <TextField select fullWidth label="Provedor (BSP)" value={form.provedorwhatsapp} disabled={saving || loadFailed} onChange={(e) => setForm((old) => ({ ...old, provedorwhatsapp: Number(e.target.value) }))} variant="outlined" margin="normal">
            {provedores.map((nome, id) => <MenuItem key={id} value={id}>{nome}</MenuItem>)}
          </TextField>
          {Number(form.provedorwhatsapp) === 6 ? <div>
            <Typography variant="subtitle1" style={{ marginTop: 16 }}>Link2Bot — integração exclusiva CRM Web</Typography>
            <TextField fullWidth margin="normal" variant="outlined" label="URL da API Link2Bot (HTTPS)" value={form.urllink2bot || ''} disabled={saving || loadFailed} onChange={(e) => setForm((old) => ({ ...old, urllink2bot: e.target.value }))} helperText="Informe a URL base de integração fornecida pelo Link2Bot; não inclua o identificador de uma requisição específica." />
            <TextField fullWidth margin="normal" variant="outlined" type="password" label="Novo Bearer Token" autoComplete="new-password" value={form.tokenlink2bot || ''} disabled={saving || loadFailed} onChange={(e) => setForm((old) => ({ ...old, tokenlink2bot: e.target.value }))} helperText={form.tokenlink2botconfigurado ? 'Token cadastrado. Deixe em branco para mantê-lo.' : 'Informe o token fornecido pelo Link2Bot.'} />
            <Typography variant="body2" color="textSecondary">O token será enviado como Authorization: Bearer &lt;token&gt;. Esta tela configura o BSP; o envio de mensagens será integrado separadamente.</Typography>
          </div> : Number(form.provedorwhatsapp) === 5 ? <div>
            {[
              ['urlbasewhatsappcloudapi', 'URL base da API'],
              ['phonenumberidwhatsappcloudapi', 'Phone Number ID'],
              ['businessaccountwhatsappcloudapi', 'WhatsApp Business Account ID'],
              ['businessidwhatsappcloudapi', 'Business ID']
            ].map(([field, label]) => <TextField key={field} fullWidth margin="normal" variant="outlined" label={label} value={form[field] || ''} disabled={saving || loadFailed} onChange={(e) => setForm((old) => ({ ...old, [field]: e.target.value }))} />)}
            <TextField fullWidth margin="normal" variant="outlined" type="password" label="Novo Access Token (deixe vazio para manter o atual)" autoComplete="new-password" value={form.accesstokenwhatsappcloudapi || ''} disabled={saving || loadFailed} onChange={(e) => setForm((old) => ({ ...old, accesstokenwhatsappcloudapi: e.target.value }))} />
          </div> : Number(form.provedorwhatsapp) > 0 ? <Typography color="textSecondary">Provedor selecionado. As credenciais específicas já cadastradas no desktop serão preservadas; a edição dessas credenciais será disponibilizada em etapa posterior.</Typography> : null}
        </div>}
        <div className={classes.actions}>
          <Button variant="contained" color="primary" onClick={salvar} disabled={saving || loadFailed}>Salvar</Button>{' '}
          <Button onClick={() => { setForm({ ...original }); setMessage(''); }} disabled={saving || loadFailed}>Cancelar</Button>
        </div>
        {message && <Typography className={classes.message} color={error ? 'error' : 'primary'}>{message}</Typography>}
      </CardContent></Card>
    </div>
  );
}
